import {
    firePerimeterHoverHandler,
    flightPathImagePointHoverHandler,
    flightPathsHoverHandler,
    hotspotPointHoverHandler,
    iconsHoverHandler,
    lightningStrikeHoverHandler,
    tooltipGenerator,
} from "features/map/hover/module"
import { LayerId } from "./constants"

// we setup predefined content generators per layer id
// important, to make this work for other ids, make sure you name them correctly!
export const layerSpecificTooltipGenerator = tooltipGenerator({
    [LayerId.HotspotPoints]: hotspotPointHoverHandler,
    [LayerId.FlightPathImagePoints]: flightPathImagePointHoverHandler,
    [LayerId.FlightPaths]: flightPathsHoverHandler,
    [LayerId.Icons]: iconsHoverHandler,
    [LayerId.FirePerimeters]: firePerimeterHoverHandler,
    [LayerId.LightningStrikeIcons]: lightningStrikeHoverHandler,
})
